<template>
  <div>
    <div class="kkday-toolbar">
      <div class="toolbar-title">{{ $lt('景点订单') }}</div>
      <div class="toolbar-tip">{{ $lt('商城中的景点门票与体验订单会显示在这里') }}</div>
    </div>

    <div class="zt5 kkday-card" v-if="list.length > 0" v-for="(itm, i) in list" :key="itm.id || i">
      <div class="tz2">
        <div class="tt kkday-card-head">
          <div class="sn">
            <img class="logo" src="~@/../static/v2/order/logo.png" mode="widthFix"/>
            {{ itm.sn }}
          </div>
          <div class="kkday-head-extra">
            <div class="kkday-create-time">{{ $lt('下单时间') }} {{ formatDateTime(itm.created_at) }}</div>
            <div :class="'status status_' + getStatusClass(itm)">
              {{ getStatusText(itm) }}
            </div>
          </div>
        </div>
      </div>

      <div class="kkday-main">
        <div class="kkday-primary">
          <div class="kkday-product-row">
            <div class="kkday-cover" v-if="itm.product && itm.product.img_list && itm.product.img_list.length">
              <img :src="itm.product.img_list[0]" alt="">
            </div>
            <div class="kkday-product-grid">
              <div class="kkday-info-col kkday-info-col--product">
                <div class="kkday-col-label">{{ $lt('商品信息') }}</div>
                <div class="kkday-title">{{ getProductTitle(itm) }}</div>
                <div class="kkday-package">{{ getPackageTitle(itm) }}</div>
              </div>

              <div class="kkday-info-col kkday-info-col--date">
                <div class="kkday-col-label">{{ $lt('出行日期') }}</div>
                <div class="kkday-col-value">{{ getServiceDate(itm) }}</div>
              </div>

              <div class="kkday-info-col kkday-info-col--qty">
                <div class="kkday-col-label">{{ $lt('数量') }}</div>
                <div class="kkday-col-value">x{{ getQuantity(itm) }}</div>
              </div>

              <div class="kkday-info-col kkday-info-col--slot" v-if="itm.event_time">
                <div class="kkday-col-label">{{ $lt('出行时段') }}</div>
                <div class="kkday-col-value">{{ itm.event_time }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="boot1 kkday-detail-row">
          <div class="kkday-side">
            <div class="price-label">{{ $lt('订单金额') }}</div>
            <div class="price">
              ¥{{ formatAmount(itm.b2c_total_price) }}
            </div>
            <div class="boot2">
              <div class="btns">
                <div class="b_tn" v-if="itm.order_status === 'pending'" @click="jump('/shop/pay?sn=' + itm.sn)">
                  {{ $lt('立即支付') }}
                </div>
                <div class="b_tn" v-if="canApplyRefund(itm)" @click="$emit('apply-refund', itm)">
                  {{ $lt('申请退款') }}
                </div>
                <div class="b_tn" @click="jump('/shop/detail?orderNo=' + itm.sn)">
                  {{ $lt('查看详情') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="list.length == 0">
      <el-empty marginTop="200" margin mode="data"></el-empty>
      <div style="height: 200px;"></div>
    </div>

    <el-pagination
      v-if="pagination && pagination.total > 0"
      background
      layout="prev, pager, next"
      :current-page="pagination.current_page"
      :page-size="pagination.per_page"
      :total="pagination.total"
      @current-change="change_page"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'goods_order_list',
  props: {
    list: {
      type: Array,
      required: true
    },
    pagination: {
      type: Object,
      default() {
        return {
          current_page: 1,
          per_page: 10,
          total: 0
        };
      }
    }
  },
  methods: {
    jump(path) {
      this.$emit('jump', path);
    },
    change_page(page) {
      this.$emit('change-page', page);
    },
    getStatusText(item) {
      const map = {
        pending: this.$lt('待付款'),
        paid: this.$lt('已付款'),
        send: this.$lt('已发货'),
        cancelled: this.$lt('已取消'),
        refunded: this.$lt('已退款')
      };
      if (item.pay_status === 'refunding') {
        return this.$lt('退款中');
      }
      return map[item.order_status] || item.order_status || this.$lt('未知状态');
    },
    getStatusClass(item) {
      const map = {
        pending: 0,
        paid: 2,
        send: 2,
        cancelled: 4,
        refunded: 4
      };
      return map[item.order_status] || 1;
    },
    canApplyRefund(item) {
      if (!item) return false;
      return !!(item.sts && item.sts.can_refunded);
    },
    getProductTitle(item) {
      return item.product && item.product.prod_name ? item.product.prod_name : this.$lt('商品编号：{0}', item.prod_no || '-');
    },
    getPackageTitle(item) {
      if (item.package && item.package.pkg_name) return item.package.pkg_name;
      if (item.pkg_no) return this.$lt('套餐编号：{0}', item.pkg_no);
      return this.$lt('套餐信息');
    },
    getServiceDate(item) {
      if (!item.s_date) return this.$lt('未配置服务日期');
      const start = this.formatDate(item.s_date);
      if (item.e_date && item.e_date !== item.s_date) {
        return start + ' ' + this.$lt('至') + ' ' + this.formatDate(item.e_date);
      }
      return start;
    },
    getQuantity(item) {
      if (item.num) return item.num;
      if (!item.skus || !item.skus.length) return 1;
      return item.skus.reduce((sum, sku) => sum + Number(sku.qty || 0), 0);
    },
    formatDate(value) {
      if (!value) return '-';
      return String(value).slice(0, 10);
    },
    formatDateTime(value) {
      if (!value) return '-';
      return String(value).replace('T', ' ').slice(0, 16);
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(2);
    },
    getExtraField(item, key) {
      return item.extra && item.extra[key] ? item.extra[key] : '';
    },
    getTravelerNames(item) {
      const custom = item.extra && item.extra.custom ? item.extra.custom : [];
      return custom
        .filter((traveler) => traveler.cus_type === 'cus_01' || traveler.cus_type === 'cus_02')
        .map((traveler) => {
          return [traveler.native_last_name, traveler.native_first_name].filter(Boolean).join('') ||
            [traveler.english_first_name, traveler.english_last_name].filter(Boolean).join(' ');
        })
        .filter(Boolean);
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('./pc_order.scss');

.kkday-toolbar {
  margin-bottom: 18px;
}

.toolbar-title {
  color: #1f2937;
  font-size: 24px;
  font-weight: 700;
}

.toolbar-tip {
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
}

.kkday-card {
  width: 100%;
  flex: 0 0 100%;
  margin: 0 0 16px;
  padding: 0 20px 0;
  border-radius: 8px;
  box-shadow: none;
  border: 1px solid #e5e7eb;
}

.kkday-card:hover {
  transform: none;
  box-shadow: none;
  border-color: #d1d5db;
}

.kkday-card-head {
  margin-bottom: 0;
  padding: 16px 0 14px;
  border-bottom: 1px solid #eef2f7;
}

.kkday-head-extra {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  flex-shrink: 0;
}

.kkday-create-time {
  color: #94a3b8;
  font-size: 12px;
  white-space: nowrap;
}

.kkday-main {
  display: flex;
  gap: 28px;
  align-items: stretch;
  padding: 18px 0 20px;
}

.kkday-primary {
  min-width: 0;
  flex: 1;
}

.kkday-product-row {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.kkday-detail-row {
  flex: 0 0 180px;
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  padding: 0 0 0 24px;
  margin: 0;
  border-left: 1px solid #eef2f7;
}

.kkday-cover {
  width: 220px;
  height: 132px;
  overflow: hidden;
  border-radius: 6px;
  background: #eef2f7;
  flex-shrink: 0;
}

.kkday-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.kkday-product-grid {
  min-width: 0;
  flex: 1;
  display: grid;
  grid-template-columns: minmax(320px, 1.3fr) 180px 90px 140px;
  gap: 24px;
  align-items: center;
  min-height: 132px;
}

.kkday-info-col {
  min-width: 0;
}

.kkday-info-col--product {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.kkday-col-label {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
}

.kkday-col-value {
  margin-top: 12px;
  color: #334155;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.45;
  word-break: break-word;
}

.kkday-title {
  color: #1f2937;
  margin-top: 10px;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.35;
  max-height: 64px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.kkday-package {
  margin-top: 10px;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.5;
  max-height: 45px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.kkday-side {
  width: 150px;
  flex: 0 0 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  margin-top: 0;
  padding-top: 0;
  border-top: 0;
}

.price-label {
  color: #94a3b8;
  font-size: 12px;
  letter-spacing: 0.08em;
}

.kkday-side .price {
  margin-top: 8px;
  font-size: 28px;
  color: #dc2626;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.kkday-side .boot2 {
  margin-top: 18px;
  padding-top: 0;
  border-top: 0;
  width: 100%;
}

.kkday-side .btns {
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
}

.kkday-side .b_tn {
  min-width: 120px;
  text-align: center;
}

@media (max-width: 1280px) {
  .kkday-card {
    padding: 0 16px;
  }

  .kkday-card-head {
    padding: 14px 0 12px;
  }

  .kkday-main {
    gap: 20px;
    padding: 16px 0 18px;
  }

  .kkday-product-row {
    gap: 18px;
  }

  .kkday-detail-row {
    flex: 0 0 154px;
    padding-left: 18px;
  }

  .kkday-cover {
    width: 160px;
    height: 108px;
  }

  .kkday-product-grid {
    grid-template-columns: minmax(0, 1.2fr) 132px 72px;
    gap: 16px;
    min-height: 108px;
  }

  .kkday-title {
    font-size: 20px;
    max-height: 56px;
  }

  .kkday-col-value {
    margin-top: 8px;
    font-size: 16px;
  }

  .kkday-info-col--slot {
    display: none;
  }

  .kkday-side {
    width: 100%;
    flex: 0 0 100%;
    align-items: flex-end;
  }

  .kkday-side .price {
    font-size: 24px;
  }

  .kkday-side .b_tn {
    min-width: 104px;
  }
}

@media (max-width: 960px) {
  .kkday-card {
    padding: 0 16px;
  }

  .kkday-card-head {
    align-items: flex-start;
  }

  .kkday-head-extra {
    align-items: flex-end;
    flex-direction: column;
    gap: 8px;
  }

  .kkday-product-row,
  .kkday-detail-row {
    flex-direction: column;
  }

  .kkday-detail-row {
    flex: none;
    border-left: 0;
    border-top: 1px solid #eef2f7;
    padding-left: 0;
    padding-top: 18px;
  }

  .kkday-cover {
    width: 100%;
    height: 220px;
  }

  .kkday-product-grid {
    grid-template-columns: 1fr;
    gap: 14px;
    min-height: 0;
  }

  .kkday-side {
    width: 100%;
    flex: none;
    align-items: flex-start;
  }

  .kkday-side .price {
    text-align: left;
  }

  .kkday-side .btns {
    justify-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods_order_list.vue